export function fetchNearestRateDatasForFixedRate( heatRates, convRate ) {
  let rateDatas = [];
  heatRates.forEach(item => {
    let rateData = nearestRateData(item.rawData, convRate);
    rateDatas.push({heatRate: item.heatRate, data: rateData});
  });

  return rateDatas;
}

export function fetchFwoSlopDatasForFixedRate( arr ) {
  let result = [];
  arr.forEach(item => {
    result.push([1000 / item.data.temperatureK, Math.log10(item.heatRate)])
  });

  return result;
}

export function nearestRateData( arr, rate ) {
  let newArr = arr.slice(0);
  newArr.sort(function ( a, b ) {
    return Math.abs(a.conversionRate - rate) - Math.abs(b.conversionRate - rate);
  });

  let result = newArr[ 0 ];
  newArr.splice(0, newArr.length);
  return result;
}

export function fetchKasSlopDatasForFixedRate( arr ) {
  let result = [];
  arr.forEach(item => {
    let ptt = item.heatRate / Math.pow(item.data.temperatureK, 2);
    result.push([1000 / item.data.temperatureK, Math.log(ptt)])
  });

  return result;
}

export function fetchFMSlopDatasForFixedRate( arr ) {
  let result = [];
  arr.forEach(item => {
    result.push([1000 / item.data.temperatureK, Math.log(item.data.dadt)])
  });

  return result;
}

export function calculateLnAandNForFuntion43( xArr, yArr, len) {
  let newArr = [];

  for(let i = 0; i < len; i++) {
    newArr.push([Math.log(1 - xArr[i]), yArr[i]])
  }

  return fitLine(newArr);
}

export function fitLine( arr ) {
  /*y = Ax + B，根据最小二乘法求出A，B*/
  let a, b;
  let len = arr.length;
  let xmean = 0.0, ymean = 0.0;
  arr.map(item => {
    xmean += item[0];
    ymean += item[1];
  });

  xmean /= len;
  ymean /= len;

  let sumx2 = 0.0, sumxy = 0.0;

  arr.map(item => {
    let temp = item[0] - xmean;
    sumx2 += temp * temp;
    sumxy += (item[1] - ymean) * temp;
  });

  a = sumxy / sumx2;
  b = ymean - a * xmean;

  return { a: a, b: b }
}

export function calculateHxFwo( e, kVal) {
  let x = e / (8.314 * kVal);
  let hx = (Math.pow(x,4) + 18* Math.pow(x,3) + 86*Math.pow(x,2) + 96*x) / (Math.pow(x,4) + 20* Math.pow(x,3) + 120*Math.pow(x,2) + 240*x +120);
  let px = Math.exp(-x) / Math.pow(x, 2) * hx;

  return px / (0.0048 * Math.exp(-1.0516 * x));
}

export function calculateHxKas( e, kVal) {
  let x = e / (8.314 * kVal);
  let hx = (Math.pow(x,4) + 18* Math.pow(x,3) + 86*Math.pow(x,2) + 96*x) / (Math.pow(x,4) + 20* Math.pow(x,3) + 120*Math.pow(x,2) + 240*x +120);

  return hx;
}



// WEBPACK FOOTER //
// ./src/components/calculate.js